import { render, staticRenderFns } from "./CharacterImporter.vue?vue&type=template&id=b15ceb4c&scoped=true&"
import script from "./CharacterImporter.vue?vue&type=script&lang=js&"
export * from "./CharacterImporter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15ceb4c",
  null
  
)

export default component.exports